<template>
<div class="mine-page" v-loading="pageLoading">
  <examin-header title="考试详情"></examin-header>
  <div class="result" v-if="info">
    状态说明：<p class="green">正确</p>{{info.on_number}}道  <p class="red">错误</p> {{info.off_number}}道
  </div>
  <div class="list">
     <p class="item" :key="index" :class="{red:!item.status}"  v-for="(item,index) in list"  @click="toDetail(index)">
        {{index+1}}
     </p>
  </div>
</div>
</template>

<script>
import ExaminHeader from '../components/ExaminHeader2.vue';
export default {
  name: "cert",
  components:{ExaminHeader},
  data() {
    return {
      pageLoading: true,
      info:null,
      list:[]
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getData();
  },
  destroyed() {},
  computed: {
    plat() {
      return this.$store.state.plat_id
    }
  },
  methods: {
    toDetail(index) {
      this.$router.push({
        path:'./examinList',
        query:{
          currentIndex:index,
          id:this.$route.query.examinId,
          resultId:this.id
        }
      })
  },
    async getData() {
      this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        url: "/api/flat/test/detail",
        data: {
          test_report_id: this.id,
        },
      });
      this.pageLoading = false;
      if (res.code == 0) {
        this.list = res.data.list;
        this.info = res.data
      } else {
        this.$toast(res.msg);
      }
    },

  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    // console.log(to)
    next()
  },

};
</script>

<style lang="scss" scoped>
.mine-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.result{
  background: #F7F8FA;
  width: 100vw;
  height: 90px;
  display: flex;
  align-items: center;
  padding: 0 27px;
  box-sizing: border-box;
  font-size: 30px;
}
.result .green{
  color: #5FD131;
  margin-right: 14px;
}
.result .red{
  color: #FF4D41;
  margin-right: 14px;
  margin-left: 50px;
}
.list{
  flex:1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding-top: 62px;
  }
  .list .item{
    float: left;
    width: 12vw;
    height: 12vw;
    border: 1px solid #A7B3BF;
    text-align: center;
    line-height: 12vw;
    border-radius: 50%;
    margin: 0 2vw 52px;
    font-size: 34px;
    box-sizing: border-box;

  }
  .list .item:nth-child(6n+1){
      margin-left: 4vw;
  }
  .list .item:nth-child(6n+6){
      margin-right: 4vw;
  }
  .list .red{
    background: #FFF1EE;
    border-color: #FFF1EE;
    color: #FF4D41;
  }
</style>

<style lang="scss">

</style>
